import { render, staticRenderFns } from "./TopPortfolioValue.vue?vue&type=template&id=319da3d0&"
import script from "./TopPortfolioValue.vue?vue&type=script&lang=js&"
export * from "./TopPortfolioValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports